// Libs
import React from 'react';
import { Card, Tooltip } from 'antd';
// Utils
import { formatNumber } from '../../../../../../utils/libs';
import { formatDate } from '../../../../../../utils/libs/dateFormats';
// Styles
import './PaymentLineResumeCard.css';

const { Meta } = Card;

export default function PaymentLineResumeCard(props) {
	const {
		id,
		line,
		order_id,
		odt_id,
		description,
		amount,
		tracts,
		apply_to_name,
		payment_id,
		action_label,
		creator_name,
		entity_name,
		created_at,
		updated_at,
		customProps,
	} = props;
	const {
		coinSymbol,
		orders = [],
		getOrder,
		mutate1ObjectInOrders,
		profile,
	} = customProps || {};
	const amountPrice = formatNumber.new(amount, coinSymbol, 2);
	const dateFormat = profile?.user?.settings?.date_format || 'DD/MM/YYYY';
	const dateTimeFormat = /[Hhms]/.test(dateFormat)
		? dateFormat
		: `${dateFormat} HH:mm`;
	const getFormattedDate = value => {
		if (!value) return '';
		const formattedValue = formatDate(value, profile, dateTimeFormat);
		return formattedValue && formattedValue !== 'Invalid Date'
			? formattedValue
			: value;
	};
	const createdAtFormatted = getFormattedDate(created_at);
	const updatedAtFormatted = getFormattedDate(updated_at);

	return (
		<Meta
			id='payment_line-resume-card-container'
			title={
				<div className='payment_line-resume-body'>
					<div className='payment_line-resume-title'>
						<div className='payment_line-resume-title-line-creator-container'>
							<Tooltip
								placement='top'
								className='payment_line-resume-title-line'
								title={description}
							>
								<span>{line}</span>
							</Tooltip>
							<div style={{ height: '20px', overflow: 'auto hidden' }}>
								<span className='payment_line-resume-concept-item'>
									Creado por:
								</span>
								<span className='payment_line-resume-concept-value'>
									{creator_name} - {entity_name}
								</span>
							</div>
						</div>

						<div className='payment_line-resume-price-action-container'>
							<span className='payment_line-resume-price'>{amountPrice}</span>
							<span className='payment_line-resume-action'>{action_label}</span>
						</div>
					</div>

					<div className='payment_line-resume-footer'>
						<div>
							<div style={{ height: '18px' }}>
								<span className='payment_line-resume-concept-item'>
									Tracto:
								</span>
								<span className='payment_line-resume-concept-value'>
									{tracts}
								</span>
							</div>
							<div style={{ height: '18px' }}>
								<span className='payment_line-resume-concept-item'>Fecha:</span>
								<span className='payment_line-resume-concept-value'>
									{createdAtFormatted}
								</span>
							</div>
							<div style={{ height: '18px' }}>
								<span className='payment_line-resume-concept-item'>
									Actualizado:
								</span>
								<span className='payment_line-resume-concept-value'>
									{updatedAtFormatted}
								</span>
							</div>
							<div>
								<span className='payment_line-resume-concept-item'>Orden:</span>
								{order_id && (
									<span
										className='payment_line-resume-order'
										onClick={() => {
											if (
												!orders.filter(ord => ord.order_id === order_id)[0] &&
												getOrder
											)
												getOrder(order_id);
											mutate1ObjectInOrders &&
												mutate1ObjectInOrders('getOrderInformationModal', {
													order_id,
													isOpen: true,
												});
										}}
									>
										{odt_id}
									</span>
								)}
							</div>
						</div>
					</div>
				</div>
			}
		/>
	);
}
